<div class="map-container" [class.loading]="!isReady">
  <input *ngIf="withSearch" [ngModel]="searchText" class="map-search-input" #autocomplete type="text" size="50" placeholder="Select Address" />
  <div class="new-map">
    <div id="map"></div>
    <div id="map-overlay" class="map-overlay"></div>
  </div>
  <app-page-spinner *ngIf="!isReady" mode="indeterminate" color="primary" [strokeWidth]="2" [diameter]="20" [style.margin-left.px]="10"></app-page-spinner>
</div>
